import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BatchSampleField {
  fieldId: number;
  fieldName: string;
  farmName: string;
}

@Injectable({ providedIn: 'root' })
export class BatchCreateSamplesDataService {
  private selectedFields$ = new BehaviorSubject<BatchSampleField[]>([]);
  private seasonId$ = new BehaviorSubject<number>(0);

  get selectedFields() { return this.selectedFields$.value; }
  get seasonId() { return this.seasonId$.value; }

  setData(fields: BatchSampleField[], seasonId: number): void {
    this.selectedFields$.next(fields);
    this.seasonId$.next(seasonId);
  }

  clear(): void {
    this.selectedFields$.next([]);
    this.seasonId$.next(0);
  }
}
